exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-debtor[data-v-6b5869f3]{color:#fff;text-align:center;text-transform:uppercase;font-size:12px;line-height:10px;height:24px;//width:40px;background-color:#fe9780}.rotate[data-v-6b5869f3]{transform:rotate(180deg)}.reader[data-v-6b5869f3]{color:#72809d;font-size:16px;font-weight:400}.book[data-v-6b5869f3],.reader[data-v-6b5869f3]{cursor:pointer}.book[data-v-6b5869f3]{color:#a7afba;font-size:13px;padding:unset;display:block}.btn-debtor.not-debtor[data-v-6b5869f3]{background:#ccc}", ""]);

// exports
